import React, { useState, useRef, useEffect } from "react";
import { Input, Popover, Checkbox, Button, Badge, Tooltip, Switch } from "antd";
import { MenuOutlined, UserOutlined, MessageOutlined } from "@ant-design/icons";
import FilterIcon from "../../Assets/filter.svg";
import ArchiveIcon from "../../Assets/archivemain.svg";
import UnarchiveIcon from "../../Assets/unarchive.svg";
import ListArrow from "../../Assets/listArrow.svg";
import RightIcon from "../../Assets/rightIcon.svg";
import "../../styles/search/search.scss";

const ChatHeader = ({ 
  searchQuery = "", 
  onSearchChange,
  searchMode = "candidate",
  onSearchModeChange,
  filterData = [],
  selectedAdverts = [],
  setSelectedAdverts = () => {},
  showArchived = false,
  onArchiveClick = () => {}
}) => {
  const [visibleFilter, setVisibleFilter] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [isCompact, setIsCompact] = useState(
    typeof window !== "undefined" ? window.innerWidth <= 992 : false
  );
  const inputRef = useRef(null);

  useEffect(() => {
    const handleResize = () => setIsCompact(window.innerWidth <= 992);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  
  const advertIdsfinal = filterData.flatMap(
    (item) => item.adverts?.map((ad) => ad._id) || []
  );

  const handleSelectAll = () => {
    if (selectedAdverts.length > 0) {
      setSelectedAdverts([]);
    } else {
      setSelectedAdverts([...advertIdsfinal]);
    }
  };

  const handleCampaignClick = (campaign) => {
    const advertIds = campaign?.adverts?.map((adv) => adv._id) || [];
    const allSelected = advertIds.every((id) => selectedAdverts.includes(id));
    
    const newSelected = allSelected
      ? selectedAdverts.filter((id) => !advertIds.includes(id))
      : [...new Set([...selectedAdverts, ...advertIds])];
    
    setSelectedAdverts(newSelected);
  };

  const handleAdvertClick = (advertId) => {
    const newSelected = selectedAdverts.includes(advertId)
      ? selectedAdverts.filter((id) => id !== advertId)
      : [...selectedAdverts, advertId];
    
    setSelectedAdverts(newSelected);
  };


  return (
    <>
      {/* Header Section */}
      <div
        className="chat-container"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "12px",
          position: "relative",
          width: "100%",
          flexWrap: "wrap",
        }}
      >
        {!showArchived && (
          <>
            <div style={{ flex: "1 1 280px", minWidth: "240px" }}>
              <Input
                ref={inputRef}
                placeholder={
                  isCompact
                    ? "Search..."
                    : searchMode === "candidate"
                    ? "Search By Candidate, Campaign, Advert, Or Company..."
                    : "Search By Candidate, Campaign, Advert, Company or Chats "
                }
                className="chat-main-search"
                style={{ fontSize: "16px", height: "50px", width: "100%" }}
                value={searchQuery}
                onChange={(e) => onSearchChange?.(e.target.value)}
                allowClear
                prefix={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M19.0002 19.0002L14.6572 14.6572M14.6572 14.6572C15.4001 13.9143 15.9894 13.0324 16.3914 12.0618C16.7935 11.0911 17.0004 10.0508 17.0004 9.00021C17.0004 7.9496 16.7935 6.90929 16.3914 5.93866C15.9894 4.96803 15.4001 4.08609 14.6572 3.34321C13.9143 2.60032 13.0324 2.01103 12.0618 1.60898C11.0911 1.20693 10.0508 1 9.00021 1C7.9496 1 6.90929 1.20693 5.93866 1.60898C4.96803 2.01103 4.08609 2.60032 3.34321 3.34321C1.84288 4.84354 1 6.87842 1 9.00021C1 11.122 1.84288 13.1569 3.34321 14.6572C4.84354 16.1575 6.87842 17.0004 9.00021 17.0004C11.122 17.0004 13.1569 16.1575 14.6572 14.6572Z"
                      stroke="#091647"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                }
                suffix={
                  <Tooltip
                    title={
                      searchMode === "candidate"
                        ? "Toggle to search chats"
                        : "Toggle to search candidates"
                    }
                    placement="bottom"
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: isCompact ? "4px" : "6px",
                        cursor: "pointer",
                        flexShrink: 0,
                        whiteSpace: "nowrap",
                      }}
                    >
                      <UserOutlined
                        style={{
                          fontSize: isCompact ? "15px" : "18px",
                          color: searchMode === "candidate" ? "#091647" : "#aaa",
                          transition: "color 0.2s",
                        }}
                      />
                      <Switch
                        size={isCompact ? "small" : "default"}
                        checked={searchMode === "chat"}
                        onChange={(checked) => {
                          onSearchModeChange?.(checked ? "chat" : "candidate");
                          setTimeout(() => inputRef.current?.focus(), 0);
                        }}
                        style={{ background: "#091647" }}
                      />
                      <MessageOutlined
                        style={{
                          fontSize: isCompact ? "15px" : "18px",
                          color: searchMode === "chat" ? "#091647" : "#aaa",
                          transition: "color 0.2s",
                        }}
                      />
                    </div>
                  </Tooltip>
                }
              />
            </div>

            <Popover
              overlayClassName="chat-filter-popover"
              arrow={false}
              content={
                <div
                  style={{
                    width: 300,
                    background: "#fff",
                    borderRadius: 8,
                    padding: 15,
                    boxShadow: "0px 4px 10px rgba(0,0,0,0.15)",
                  }}
                >
                  <h4
                    style={{
                      color: "#1E1E1E",
                      fontSize: 14,
                      fontStyle: "normal",
                      fontWeight: 700,
                      lineHeight: "normal",
                      textTransform: "uppercase",
                      alignSelf: "stretch",
                      marginBottom: 8,
                    }}
                  >
                    FILTERS
                  </h4>

                  <Checkbox
                    checked={selectedAdverts.length > 0}
                    onChange={handleSelectAll}
                    style={{ marginBottom: 10 }}
                  >
                    {selectedAdverts.length > 0 ? "Deselect All" : "Select All"}
                  </Checkbox>

                  <Input
                    placeholder="Search campaigns or adverts"
                    value={searchKeyword}
                    onChange={(e) => setSearchKeyword(e.target.value)}
                    allowClear
                    style={{ marginBottom: 12 }}
                  />

                  <h4
                    style={{
                      color: "#1E1E1E",
                      marginTop: 8,
                      fontSize: 14,
                      fontStyle: "normal",
                      fontWeight: 700,
                      lineHeight: "normal",
                      textTransform: "uppercase",
                      alignSelf: "stretch",
                      marginBottom: 8,
                      position: "relative",
                      display: "inline-block",
                    }}
                  >
                    campaigns & Adverts
                  </h4>
                  <div className="campaignListContainer">
                    {(searchKeyword.trim() === ""
                      ? filterData
                      : filterData
                          ?.filter((item) => {
                            const campaignMatch = item?.name
                              ?.toLowerCase()
                              .includes(searchKeyword.toLowerCase());

                            const advertMatch = Array.isArray(item?.adverts)
                              ? item.adverts.some((ad) =>
                                  ad?.jobTitle?.name
                                    ?.toLowerCase()
                                    .includes(searchKeyword.toLowerCase())
                                )
                              : false;

                            return campaignMatch || advertMatch;
                          })
                          ?.map((item) => {
                            const campaignMatch = item?.name
                              ?.toLowerCase()
                              .includes(searchKeyword.toLowerCase());

                            return {
                              ...item,
                              adverts: Array.isArray(item?.adverts)
                                ? campaignMatch
                                  ? item.adverts
                                  : item.adverts.filter((ad) =>
                                      ad?.jobTitle?.name
                                        ?.toLowerCase()
                                        .includes(searchKeyword.toLowerCase())
                                    )
                                : [],
                            };
                          })
                    )?.map((item, index) => {
                      const advertIds = item?.adverts?.map((adv) => adv._id) || [];
                      const allSelected = advertIds.every((id) => selectedAdverts.includes(id));
                      
                      return (
                        <div key={index} className="inviteCampaignDropDown">
                          <div
                            onClick={() => handleCampaignClick(item)}
                            className={`campaignContainer cursor-pointer ${
                              allSelected ? "activeCampaign" : ""
                            }`}
                            style={{
                              padding: "5px 20px",
                              background: allSelected ? "#e3e9fc" : "transparent",
                            }}
                          >
                            <span className="name" style={{ color: "#091647", fontSize: "14px", fontWeight: 400 }}>
                              {item?.name}
                            </span>
                          </div>
                          <div className="advertContainer">
                            {item?.adverts?.map((advert) => {
                              const isSelected = selectedAdverts.includes(advert._id);
                              return (
                                <div
                                  key={advert._id}
                                  onClick={() => handleAdvertClick(advert._id)}
                                  className={`cursor-pointer ${
                                    isSelected ? "activeAdvertItem" : "advertItem"
                                  }`}
                                  style={{
                                    padding: "5px 20px 5px 40px",
                                    marginBottom: "10px",
                                    background: isSelected ? "#e3e9fc" : "transparent",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                    <img src={ListArrow} alt="icon" style={{ width: "12px", height: "12px" }} />
                                    <span className="name" style={{ color: "#091647", fontSize: "14px", fontWeight: 400 }}>
                                      {advert?.jobTitle?.name}
                                    </span>
                                  </div>
                                  {isSelected && (
                                    <img src={RightIcon} alt="selected" style={{ width: "16px", height: "16px" }} />
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              }
              trigger="click"
              placement="bottomLeft"
              open={visibleFilter}
              onOpenChange={(visible) => setVisibleFilter(visible)}
              overlayStyle={{
                border: "none",
                boxShadow: "none",
              }}
              overlayInnerStyle={{
                backgroundColor: "#fff",
                padding: "0px",
              }}
            >
              <Badge
                count={selectedAdverts.length}
                size="default"
                style={{
                  zIndex: 999,
                }}
              >
                <Button
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                    background: "#F8FAFC",
                    border: "1px solid #E2E8F0",
                    borderRadius: "8px",
                    padding: "20px 12px",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#64748B",
                    cursor: "pointer",
                    boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "28px",
                      height: "28px",
                      background: "#EEF4FF",
                      borderRadius: "6px",
                    }}
                  >
                    <MenuOutlined style={{ fontSize: "16px", color: "#1638B1" }} />
                  </div>
                  Filter By
                </Button>
              </Badge>
            </Popover>
          </>
        )}

        {/* Archive List Button - Only show when not in archive list */}
        {!showArchived && (
        
            <Button
              onClick={onArchiveClick}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                background: "rgb(9, 30, 105)",
                border: "3px solid rgb(249, 207, 102)",
                borderRadius: "8px",
                padding: "20px 12px",
                fontSize: "14px",
                fontWeight: "500",
                color: "#FFFFFF",
                cursor: "pointer",
                boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "28px",
                  height: "28px",
                  background: "#FFFFFF",
                  borderRadius: "6px",
                }}
              >
                <img src={ArchiveIcon} alt="Archive" style={{ width: "16px", height: "16px" }} />
              </div>
              Archive List
            </Button>
        
        )}

      </div>
    </>
  );
};

export default ChatHeader;
